// extracted by mini-css-extract-plugin
export default {"container":"Top3Users_container__418eK"};